<template>
  <div>
    <div class="title mt-5">
      <h3 class="d-flex justify-content-center header">
        {{$t('headers.hearing_test')}}
      </h3>
    </div>
    <div class="mt-3">
      <!-- Hearing Test Calibrations -->
      <div class="content">
        <div class="d-flex justify-content-center">
          <span class="header header-2">
              {{$t('first_stage.adjust_message')}}
          </span>
        </div>

        <div>
          
          <div class="d-flex justify-content-center">
            <span class="header header-4">
                {{correctAnswersText}}
            </span>
          </div>

            <transition-group name="list" tag="div" class="row justify-content-md-center instruments-wrapper">
              <div class="flip-card col-5 col-md-4 grid-instrument" v-for="instrument in instruments" :key="instrument.id" @click="evaluateCalibrationAnswer(instrument)" :class="instrument.class">
                <div class="flip-card-inner">
                  <div class="flip-card-front">
                    <img :src="getFullImagePath(instrument)" alt="">
                  </div>
                  <div class="flip-card-back">
                    <i class="far fa-check-circle"></i>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
          
          <fade-transition :duration="250" v-if="answerWrong" class="d-flex justify-content-center mt-3">
            <span class="header header-4 header-danger">
              {{$t('first_stage.wrong_answer_message')}}
            </span>
          </fade-transition>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Instruments from '../utils/Sounds'
import FadeTransition from './Utils/FadeTransition.vue'
export default {
  props: {
    handler: {
      type: Object,
      required: true
    }
  },
  components: {
    FadeTransition
  },
  data () {
    return {
      calibrationAnswer: {
        instrument: null,
        result: null
      },
      instructionsEnded: false,
      disableButtons: false,
      correctAnswersCount: 0,
      hasStarted: false,
      instructionsFinished: false,
      instruments: Instruments.instruments.map((item, index) => {
        return {
          id: index + 1,
          name: item.name,
          image: item.image,
          class: 'no-action'
        }
      }).slice(0, 9),
      answerWrong: false
    }
  },
  mounted () {
    this.handler.hearingTestPreparation.eventEmitter.on('instructionsEnded', () => {
      this.instructionsEnded = true
    })
    this.handler.hearingTestPreparation.eventEmitter.on('firstStageEnded', () => {
      this.$emit('continue')
    })
    this.handler.hearingTestPreparation.eventEmitter.on('answer-result', (payload) => {
      this.calibrationAnswer = payload
    })
    this.handler.initPreparation()
  },
  methods: {
    updateAnswerResult: function (payload) {
      this.calibrationAnswer = payload
    },
    startStage: function () {
      this.hasStarted = true
    },
    evaluateCalibrationAnswer: function (instrument) {
      if (!this.instructionsEnded) return
      if (!this.disableButtons) {
        this.handler.evaluateInstrument(instrument.name)
        this.disableButtons = true
        setTimeout(() => {
          this.disableButtons = false 
        }, 1000)
      }
    },
    getFullImagePath: function (instrument) {
      return `public/${instrument.image}`
    },
  },
  computed: {
    correctAnswersText: function () {
      return this.$t('first_stage.number_correct_answers', {number: this.correctAnswersCount})
    }
  },
  watch: {
    calibrationAnswer: {
      handler: function (answer) {
        if (answer.instrument) {
          let instrument = this.instruments.find(item => item.name === answer.instrument)
          instrument.class = answer.result ? 'answer-correct' : 'answer-wrong'
          if (!answer.result) {
            this.answerWrong = !this.answerWrong
          } else {
            this.correctAnswersCount ++
          }
          setTimeout(() => {
            instrument.class = ''
          }, 850)
          setTimeout(() => {
            this.answerWrong = false
          }, 1500)
        }
      },
      deep: true
    },
    instructionsEnded: function (value) {
      this.instruments = this.instruments.map(item => {
        return {
          ...item,
          class: ''
        }
      })
    }
  }
}
</script>

<style scoped>
.text-evollu {
  color: #29c4a9;
}

.text-black {
  color: #181818;
}

.grid-container {
  display: grid;
  grid-template-columns: auto auto auto;
  background-color: #2196F3;
  padding: 10px;
}

.grid-instrument {
  width: 110px;
  height: 150px;
  background-size: cover;
  background-position: center;
}

@media only screen and (max-width: 768px) {
  .grid-instrument {
    width: 30px;
    height: 125px;
  }

  .instruments-wrapper {
    margin-top: 3rem;
  }
}

@media only screen and (min-width: 1350px) {
  .instruments-wrapper {
    margin: 0 10rem;
  }
  .grid-instrument:hover:not(.no-action) {
    cursor: pointer;
    border-radius: 7%;
    border: 2px solid #414244;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    transform: scale(1.05);
  }
}

.instruction-message {
  color: #414244;
}

.grid-instrument.answer-correct {
  border: 2px solid #29c4a9 !important;
}

.grid-instrument.answer-wrong {
  border: 2px solid #e34a4a !important;
  animation: shake 0.5s;
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

.grid-instrument > img {
  width: 100%;
  height: 100%;
  perspective: 1000px;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.start-calibration-btn {
  background-color: #29c4a9;
  color: #fff;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card.answer-correct .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front, .flip-card-back {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.flip-card-back {
  transform: rotateY(180deg);
  font-size: 4.5rem;
  color: #29c4a9;
}
</style>